import { cityActions } from "../slices/citySlice";
import { request } from "../../utils/request";
import { toast } from "react-toastify";
import axios from "axios";

//Fetch all departments
export function fetchAllCities() {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(`https://tabeeb-assyut-api.onrender.com/api/cities`);
      dispatch(cityActions.setCities(data));
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
//Create department
export function createCity(city) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.post(`https://tabeeb-assyut-api.onrender.com/api/cities`, city, {
        headers: {
          Authorization: "Bearer " + getState().auth.user.token,
        },
      });
      dispatch(cityActions.addCity(data));
      toast.success("تم اضافة مدينة بنجاح.");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
//Delete department
export function deleteCity(cityId) {
  return async (dispatch, getState) => {
    try {
      const { data } = await request.axios(`https://tabeeb-assyut-api.onrender.com/api/cities/${cityId}`, {
        headers: {
          Authorization: "Bearer " + getState().auth.user.token,
        },
      });
      dispatch(cityActions.deleteCity(data.cityId));
      toast.success(data?.message);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
